module.exports = __webpack_public_path__ + "img/zm.b7864d5.svg";